<div class="fieldset" [ngClass]="{'disabled' :disabled}">
  <div class="row datetime">
    <div #picker class="col input-group dropdown" [ngClass]="{'dropdown-backdrop': showBackdrop}">
      <ng-content select=".input-group-prepend"></ng-content>
      @switch (inputMode) {
        @case ('button') {
          <div class="btn btn-outline-primary" data-bs-toggle="dropdown"
               [ngClass]="!show ? 'invisible p-0' : ''"
               (click)="openCalendar(); $event.stopPropagation();">
            <ng-content></ng-content>
          </div>
        }
        @case ('input') {
          <input [(ngModel)]="formattedDate" (ngModelChange)="onDateChange()" [ngModelOptions]="{updateOn: 'blur'}"
                 [required]="required" (focus)="this.focus.emit($event)" (blur)="this.blur.emit($event)"
                 [disabled]="disabled" [id]="id ? id + '-date' : null" class="form-control validatable"
                 [ngClass]="status === 'warning' ? 'warning' : status === 'error' ? 'error' : null"
                 autocomplete="off" [placeholder]="'mmm dd, yyyy' + separator + 'mmm dd, yyyy'">
          <button #dropdownButton class="btn btn-outline-secondary fa fa-calendar-alt rounded-end"
                  data-bs-toggle="dropdown" (click)="openCalendar(); $event.stopPropagation();"
                  (focus)="this.focus.emit($event)" type="button" tabIndex="-1"></button>
        }
      }
      <div #dropdownMenu class="dropdown-menu dropdown-menu-end" onclick="event.stopPropagation()">
        <div class="row g-0 flex-md-nowrap">
          <div class="col p-3">
            @if (header) {
              <span class="h5 ms-2">{{ header }}</span>
            }
            @if (showPicker) {
              <app-date-picker [date]="_calendarStartDate" [minDate]="_minDate"
                               [range]="true" [numberOfCalendars]="numberOfMonths"
                               (dateChanged)="onDatePickerChanged($event, true)"></app-date-picker>
            }
            @if (includeTime) {
              <div class="row w-100 mx-0 p-3">
                <app-time-picker class="col" [ngModel]="startTime"
                                 (ngModelChange)="onTimeChanged($event)"></app-time-picker>
                <app-time-picker class="col" [ngModel]="endTime"
                                 (ngModelChange)="onTimeChanged($event)"></app-time-picker>
              </div>
            }
          </div>
          @if (ranges) {
            <div class="border-start-1 col-12 col-md-auto bg-body-tertiary p-3"
                 [style.min-width]="'200px'">
              <div class="w-100 position-relative">
                <div class="btn-close-wrapper rounded-circle position-absolute end-0 top-0">
                  <button type="button" class="btn-close" aria-label="Close" (click)="closeCalendar()"></button>
                </div>
              </div>
              <div class="d-flex flex-column align-items-stretch" style="margin-top: 62px;">
                @for (range of ranges; track range) {
                  <button class="btn btn-outline-primary my-1 text-start bg-white" (click)="selectRange(range)"
                          [ngClass]="{'active': utils.rangeSelected(_date, range)}">
                    {{ range.label }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
        <div class="row g-0 border-top p-3">
          <div class="col-auto d-flex align-items-center">
            <input [(ngModel)]="_dateFormatted.start" (blur)="onDateFormattedChange()"
                   autocomplete="off" class="form-control validatable" placeholder="dd-mm-yyyy">
          </div>
          <div class="col-auto d-flex align-items-center px-3">
            –
          </div>
          <div class="col-auto d-flex align-items-center">
            <input [(ngModel)]="_dateFormatted.end" (blur)="onDateFormattedChange()"
                   autocomplete="off" class="form-control validatable" placeholder="dd-mm-yyyy">
          </div>
          @if (manual) {
            <div class="col">
            </div>
            <div class="col-auto ms-auto d-flex align-items-center px-1">
              <button class="btn btn-secondary" (click)="cancelCalendar()">
                Cancel
              </button>
            </div>
            <div class="col-auto ms-auto d-flex align-items-center ps-3">
              <button class="btn btn-primary" (click)="apply()">
                Apply
              </button>
            </div>
          }
        </div>
      </div>
      <ng-content select=".input-group-append"></ng-content>
    </div>
  </div>
</div>
